import React, { useState } from 'react';
import $ from 'jquery';
import RTL from './components/Rtl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Loader from './components/Loader';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Actions } from './redux/DictionaryRedux';
import routes from './config/routes';
import { ApiServices } from './utils/ApiServices';

const OrderLayout = React.lazy(() => import('./views/orderRegister/components/OrderLayout'));
const AdminLayout = React.lazy(() => import('./components/AdminLayout/AdminLayout'));
const Error404 = React.lazy(() => import('./views/error/Error404'));
const Login = React.lazy(() => import('./views/auth/Login'));
const ForgetPassword = React.lazy(() => import('./views/auth/ForgetPassword'));
function App() {
  const [loadDic, setLoadDic] = useState(true);
  const dispatch = useDispatch();
  let location = useLocation()
  const changeTheme = () => {
    var darkTheme = localStorage.getItem('darkTheme');
    if (darkTheme) {
      $('html').addClass('dark');
      $('#changeThemeText').text('حالت روشن');
      $('#changeThemeSwitch').prop('checked', true);
    }
    else {
      $('html').removeClass('dark');
      $('#changeThemeText').text('حالت تیره');
      $('#changeThemeSwitch').prop('checked', false);
    }

  }
  const loadDictionary = async () => {
    let lan = localStorage.getItem('current_lan');
    if (!lan) {
      lan = 'fa';
      localStorage.setItem('current_lan', lan);
    }
    var result = await ApiServices.translations.get(lan);
    if (result.success) {
      var data = result.entity;
      dispatch(Actions.SetDictionary(data.translations));
      setLoadDic(false);
    }

  }
  useEffect(() => {
    loadDictionary();
    $('#changeThemeSwitch').change(function () {
      if ($(this).is(":checked")) {
        localStorage.setItem('darkTheme', "true");
      }
      else
        localStorage.removeItem('darkTheme');
      changeTheme();
    });
    changeTheme();
  }, [])
  useEffect(() => {
    var changeThemeDiv = document.getElementById("changeThemeDiv");
    // if ((location.pathname.includes("/app")||location.pathname.includes("/auth")) && changeThemeDiv) {
    //   changeThemeDiv.style.display = "flex"
    // }

    //document.getElementsByName('html')[0].className = darkTheme ? "dark" : "";
  }, [location])

  return (loadDic ? (<Loader />) :

    <RTL>
      <React.Suspense fallback={<Loader />} >
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/order/register" />} />
          <Route path="/order/*" component={OrderLayout} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/dashboard" />}
          />
          <Route path="/auth/login" component={Login} />
          <Route path="/auth/forgetPassword" component={ForgetPassword} />
          <Route path="/app/*" component={AdminLayout} />
          {routes.map(route => (
            <Route path={route.path} key={route.key} exact={route.exact} component={route.component} />
          ))}
          <Route component={Error404} />
        </Switch>
      </React.Suspense>
      <ToastContainer />

    </RTL>

  );
}

export default App;
